{
  "dismiss": "Kapat"
}
